import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  onClose: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
  maxWidth?: string;
  hideTopPadding?: boolean;
  isBackgroundTransparent?: boolean;
  testId?: string;
}

const Modal: React.FC<ModalProps> = ({
  onClose,
  children,
  fullScreen,
  maxWidth = 'max-w-lg',
  hideTopPadding = false,
  isBackgroundTransparent = false,
  testId = 'modal',
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.classList.remove('opacity-0');
      modalRef.current.classList.add('opacity-100');
    }
  }, []);

  return (
    <div
      data-testid={testId}
      className={`fixed inset-0 z-40 flex items-center justify-center ${isBackgroundTransparent ? 'bg-black bg-opacity-50' : 'bg-black'} transition-opacity duration-300`}>
      <div
        ref={modalRef}
        className={`
          bg-white opacity-0 transition-opacity duration-300
          ${fullScreen
            ? 'fixed inset-0 w-full h-full bg-black' // Full screen modal
            : `rounded-lg shadow-lg w-full ${maxWidth} mx-4 transform translate-y-4 max-h-full overflow-y-auto` // Default modal with adjustable max width and height
          }
        `}
      >
        {!fullScreen && (
          <div className="flex justify-end p-2">
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X size={24} />
            </button>
          </div>
        )}
        <div className={`${fullScreen ? 'h-full' : `${hideTopPadding? 'pb-3 px-3 sm:px-6' : 'p-6 mb-2'}`} flex flex-col`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
